<div class="modal-header"><h2 class="modal-title">Add Material</h2></div>
<div class="modal-body">
    <div class="flex-fill d-flex flex-column">
        <div class="card">
            <div class="card-body">
                <dx-form *ngIf="jobMaterial" [formData]="jobMaterial" validationGroup="mainValidationGroup">
                    <dxi-item dataField="quantity" [label]="{ text: 'Qty' }">
                        <dxi-validation-rule type="required" message="Quantity Required"> </dxi-validation-rule>
                        <dxi-validation-rule type="numeric" message="Needs to be a number"> </dxi-validation-rule>
                        <dxi-validation-rule type="range" min="1" message="Cannot be less than 1"> </dxi-validation-rule>
                    </dxi-item>
                    <dxi-item dataField="name" [label]="{ text: 'Material' }">
                        <dxi-validation-rule type="required" message="Material Required"> </dxi-validation-rule>
                    </dxi-item>
                </dx-form>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="save()">Save</button>
    <button type="button" class="btn btn-default" (click)="cancel()">Close</button>
</div>
